<template>
    <div class="add">
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>角色管理</el-breadcrumb-item>
                <el-breadcrumb-item>新增角色</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>新增角色</h2>
                <div class="item" @click="toList">角色列表</div>
            </div>
        </div>
        <div class="page-content">
            <div class="form-box">
                <el-form ref="form" :model="roleData" label-width="80px" align="left" style="width: 100%;">
                <el-form-item label="角色名称"  style="width: 200px;">
                    <el-input v-model="roleData.role_name"></el-input>
                </el-form-item>
                <el-form-item label="角色权限">
                    <el-checkbox-group v-model="type">
                        <el-checkbox label="城市代理" name="type"></el-checkbox>
                        <el-checkbox label="试驾场地代理" name="type"></el-checkbox>
                        <el-checkbox label="商展场地代理" name="type"></el-checkbox>
                        <el-checkbox label="会议场地代理" name="type"></el-checkbox>
                        <el-checkbox label="特色场地代理" name="type"></el-checkbox>
                        <el-checkbox label="拍摄场地代理" name="type"></el-checkbox>
                        <el-checkbox label="派对场地代理" name="type"></el-checkbox>
                        <el-checkbox label="亲子场地代理" name="type"></el-checkbox>
                        <el-checkbox label="学校场地代理" name="type"></el-checkbox>
                        <el-checkbox label="户外展地代理" name="type"></el-checkbox>
                        <el-checkbox label="服务商代理" name="type"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="addRole">立即创建</el-button>
                    <el-button  @click="toList">取消</el-button>
                </el-form-item>
            </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {saveRole} from '../../api/role'
    export default {
        name: "add",
        data(){
            return{
                cityOptions:[],
                roleData:{
                    role_name:''
                },
                checkAll: false,
                type:[],
                isIndeterminate: true
            }
        },
        methods:{
            addRole(){
                saveRole({role_name:this.roleData.role_name}).then(res=>{
                   if(res.code==1){
                       this.$message({
                           type: 'success',
                           message: '新增成功!'
                       });
                       this.toList();
                   }
                })
            },
            handleCheckAllChange(val) {
                this.checkedCities = val ? this.cityOptions : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.cityOptions.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.cityOptions.length;
            },
            toList(){
                this.$router.push({path: '/authority/authority'});
            }
        }
    }
</script>

<style lang="scss" scoped>
.page-content{
    padding: 20px;
    .form-box{
        padding: 20px;
        background-color: #fff;
        box-shadow: 0 4px 4px 0 #e1e5eb;
    }
}
</style>
